import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Pagination,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TextField,
  Typography
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import MainCard, {
  ErrorScreen,
  ShowNoRecordsFound,
  StyledTableCell,
  StyledTableRow
} from '../../../utils/ui_utils'
import { Close, Person, Phone } from '@mui/icons-material'
import ListTypeShimmer from '../../../utils/ui_components/shimmers/listTypeShimmer'
import moment from 'moment/moment'
import { useFetchOutlet } from '../../../modules/outlet/outletHooks'

function LedgerEntryDialog({
  initialValues,
  error,
  showPaymentWindow,
  tbpAmount,
  customerData,
  latestEntryData,
  visible,
  handleClose,
  loading,
  latestLoading,
  page,
  handlePageChange,
  pagecount,
  pageReload,
  onOutletChange
}) {
  const { outletFetchData, outletFetchLoading, outletFetchError } =
    useFetchOutlet()
  const [selectedOutlet, setSelectedOutlet] = useState(0)
  if (initialValues == undefined) initialValues = []
  if (customerData == undefined) customerData = []
  if (latestEntryData == undefined) latestEntryData = []

  const handleOutletChange = (event) => {
    setSelectedOutlet(event.target.value)
    onOutletChange(event.target.value)
  }

  useEffect(() => {
    if (outletFetchData?.data?.length > 0) {
      setSelectedOutlet(outletFetchData?.data[0]._id)
    }
  }, [outletFetchData])

  const handleOnPageChange = async (event, value) => {
    value = {
      page: value,
      outletId: selectedOutlet
    }
    handlePageChange(value)
  }

  return (
    <>
      <Dialog
        maxWidth="md"
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={visible}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          Ledger Entry
          <IconButton
            component="span"
            size="small"
            sx={{ ':hover': { backgroundColor: 'red', color: 'white' } }}
            onClick={() => {
              setSelectedOutlet(outletFetchData?.data[0]._id)
              handleClose()
            }}
            variant="contained"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container direction={'column'}>
            {/* {loading && <ListTypeShimmer />} */}
            {!loading && !latestLoading && (!error || !outletFetchError) && (
              <Grid container alignItems={'center'}>
                <Grid item>
                  <Person color="primary" />
                </Grid>
                <Grid item sx={{ pl: 1 }}>
                  <Typography variant="h6" display="inline">
                    {customerData?.name}
                  </Typography>
                </Grid>
                <Grid item sx={{ pl: 3 }}>
                  <Phone color="success" />
                </Grid>
                <Grid item sx={{ pl: 1 }}>
                  <Typography variant="h6" display="inline">
                    {customerData?.mobile}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justifyContent={'flex-end'}
                  alignItems={'center'}
                >
                  {tbpAmount > 0 && (
                    <Grid item>
                      <Grid container pr={5}>
                        <Grid item sx={{ pl: 1 }}>
                          <Typography variant="h6" display="inline">
                            TBP Bill Amount:{' '}
                          </Typography>
                        </Grid>
                        <Grid item sx={{ pl: 1 }}>
                          <Typography
                            color={'primary'}
                            variant="h6"
                            display="inline"
                          >
                            {tbpAmount.toFixed(2)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  {tbpAmount > 0 && latestEntryData?.balance - tbpAmount > 0 && (
                    <Grid item>
                      <Typography variant="h6" display="inline">
                        |
                      </Typography>
                    </Grid>
                  )}
                  {latestEntryData?.balance - tbpAmount > 0 && (
                    <>
                      <Grid item sx={{ pl: 3 }}>
                        <Typography variant="h6" display="inline">
                          {' '}
                          Payable Amount:{' '}
                        </Typography>
                      </Grid>
                      <Grid item sx={{ pl: 1, pr: 1 }}>
                        <Typography
                          variant="h6"
                          color={'primary'}
                          display="inline"
                        >
                          {(latestEntryData?.balance - tbpAmount).toFixed(2)}
                        </Typography>
                      </Grid>

                      <Grid item sx={{ pl: 3 }}>
                        <Button
                          color="success"
                          variant="contained"
                          size="small"
                          onClick={showPaymentWindow}
                        >
                          Pay
                        </Button>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            )}
            {!loading &&
              !latestLoading &&
              (!error || !outletFetchError) &&
              outletFetchData?.data?.length > 0 && (
                <Grid container>
                  <Grid item md={4} lg={4} sm={12} xs={12} sx={{ pt: 2 }}>
                    <TextField
                      size="small"
                      label="Outlet"
                      id="outlet"
                      name="outlet"
                      variant="outlined"
                      margin="dense"
                      value={selectedOutlet}
                      onChange={handleOutletChange}
                      select
                      fullWidth
                    >
                      {outletFetchData?.data?.map((outlet) => (
                        <MenuItem key={outlet._id} value={outlet._id}>
                          {outlet.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              )}
            {!loading &&
            !latestLoading &&
            !error &&
            !outletFetchError &&
            (outletFetchData?.data?.length === 0 ||
              initialValues.length === 0) ? (
              <ShowNoRecordsFound />
            ) : loading == true ||
              loading == null ||
              latestLoading == true ||
              latestLoading == null ? (
              <ListTypeShimmer />
            ) : error || outletFetchError ? (
              <ErrorScreen onClick={pageReload} />
            ) : (
              !loading &&
              !latestLoading && (
                <Grid container direction={'column'}>
                  <Grid item sx={{ pt: 5 }}>
                    <Grid container>
                      <Grid item xs sm md>
                        <MainCard content={false}>
                          <CardContent sx={{ flexGrow: 1 }}>
                            <TableContainer component={Card}>
                              <Table size="small">
                                <TableHead size="small">
                                  <StyledTableRow>
                                    <StyledTableCell align="left">
                                      Date
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                      {' '}
                                      Bill No
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                      {' '}
                                      Debit
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                      {' '}
                                      Credit
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                      {' '}
                                      Balance
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                      {' '}
                                      Remarks
                                    </StyledTableCell>
                                  </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                  {initialValues?.map((row, i) => (
                                    <StyledTableRow key={i} hover>
                                      <StyledTableCell align="left">
                                        {row?.ledger_date !== undefined &&
                                        row?.ledger_date !== null
                                          ? moment(row?.ledger_date).format(
                                              'DD-MM-YYYY'
                                            )
                                          : '-'}
                                      </StyledTableCell>
                                      <StyledTableCell align="right">
                                        {row?.bill_number !== undefined &&
                                        row?.bill_number !== null
                                          ? row?.bill_number
                                          : '-'}
                                      </StyledTableCell>
                                      <StyledTableCell align="right">
                                        {row?.debit !== undefined &&
                                        row?.debit !== null
                                          ? row?.debit.toFixed(2)
                                          : '-'}
                                      </StyledTableCell>
                                      <StyledTableCell align="right">
                                        {row?.credit !== undefined &&
                                        row?.credit !== null
                                          ? row?.credit.toFixed(2)
                                          : '-'}
                                      </StyledTableCell>
                                      <StyledTableCell align="right">
                                        {row?.balance !== undefined &&
                                        row?.balance !== null
                                          ? row?.balance.toFixed(2)
                                          : '-'}
                                      </StyledTableCell>
                                      <StyledTableCell align="left">
                                        {row?.remarks !== undefined &&
                                        row?.remarks !== null
                                          ? row?.remarks
                                          : '-'}
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </CardContent>
                          <div
                            style={{
                              marginLeft: 10,
                              marginTop: 5,
                              marginBottom: 10
                            }}
                          >
                            <Pagination
                              count={pagecount}
                              page={page}
                              color="secondary"
                              size="small"
                              boundaryCount={2}
                              siblingCount={0}
                              showFirstButton
                              showLastButton
                              onChange={handleOnPageChange}
                            />
                          </div>
                        </MainCard>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )
            )}
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default LedgerEntryDialog
